// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KrmH","content":"styles_content__3D1Tg"};